export class Brick {
  constructor() {

  }
}
